module.exports = __webpack_public_path__ + "static/media/sleep_img.6587e644.png";